import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ClientesRelatoriosPorAdvogados, FiltrosClientesRelatorios } from '@app/pages/relatorios/clientes/clientes-relatorios';
import { IdDescricao } from '@app/models/util/id-descricao';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';

@Component({
  selector: 'app-clientes-por-advogado',
  templateUrl: './clientes-por-advogado.component.html',
  styleUrls: ['./clientes-por-advogado.component.scss']
})
export class ClientesPorAdvogadoComponent implements OnInit {

  @ViewChild('relatorio') relatorio: ElementRef;
  lstUnidades: IdDescricao[] = [];
  listaAdvogados: ClientesRelatoriosPorAdvogados[] = [];

  filtros: FiltrosClientesRelatorios;
  pesquisando = false;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService
  ) {
    this.filtros = {
      Opcao: 3
    };
  }

  ngOnInit(): void {
    this.pesquisar();
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService
      .clientes(this.filtros)
      .toPromise()
      .then(data => {
        this.listaAdvogados = data;
        this.pesquisando = false;
      });
  }


  public imprimir() {
    let conteudo = document.getElementById("clientes").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Clientes Por Advogado", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    objetoFiltros.set('Emitido em', this.dataRelatorio.toLocaleString());

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    
    return stringHtml;
  }

}
